module.exports = __webpack_public_path__ + "img/train-8.7054761d.jpg";